export const routes = {
    "/:taskId/oldReferralClinicalNotes/*": {
        title: "Clinical Notes"
    },
    "/:taskId/referralClinicalNotes": {
        title: "Clinical Notes"
    },
    "/:taskId/previewReport/*": {
        title: "Report Preview"
    },
    "/:taskId/previewReport": {
        title: "Report Preview"
    },
    "/:taskId/ppqClinicalNotes": {
        title: "Clinical Notes",
    },
    "/:taskId/amendPpqClinicalNotes": {
        title: "Amend Certificate"
    }
};
